import Flood from '~/_Utility/Flood';
import Log from '~/_Utility/Log';

import Async from '~/Async';

import Masonry from 'masonry-layout';

class InstantSearch {

    /**
     * @since 2.0.0
     * @method constructor
     */
    constructor() {
        // Set up variables
        this.selector       = 'form[data-p3-instant-search]';
        this.targetSelector = 'p3-instant-search-target';
        this.itemSelector   = 'p3-instant-search-item';
        this.parentSelector = 'p3-instant-search-item-parent';

        // Run initialization
        this.init()
    }

    /**
     * Perform a fuzzy search on the filterable items.
     *
     * @since 2.0.0
     * @method fuzzySearch
     * @param string value The value to be tested
     * @param string filter The search filter from which to test
     * @return bool Flag indicating a matched search result
     */
    fuzzySearch(value, filter) {

        // If there are no search terms, everything matches
        if ('string' !== typeof filter || '' === filter.trim())
            return true;

        // Set up our search values
        var order = -1;

        // If the name is already part of the term, it matches
        if (-1 < value.indexOf(filter)) return true;

        // Iterate through the name
        for (let i = 0; i < 10; i++) {

            // Set the new order comparison value
            order = value.indexOf(filter[i], order + 1);

            // If the order was disrupted, there is no match
            if (!~order) return false;

        }

        // If we did not hit a dead end, consider it matching
        return true;

    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 2.0.0
     * @return void
     */
    init() {
        // Let them know we made it here OK
        new Log('Instant Search initialized.', 'init');

        // Search for our elements
        $(this.selector).each((i, item) => {

            // Store our context
            let context = this;
            let toggler = this.toggle;

            // Prevent the form from submittin
            $(item).on('submit', function (e) {
                e.preventDefault();
            });

            // Listen!
            $(item).on('keyup', 'input[type="text"]', function (e) {

                // Set up our helper values
                let filter = context.search;
                let flood  = (new Flood(filter, {
                    input:   this,
                    context: context
                })).gate();

                // Run the flood
                flood();

            });

        });
    }


    /**
     * Search through the communities and weed out non-matching items.
     *
     * @since 1.0.0
     * @method searchCommunities
     * @param object e The event object
     * @pararm function toggler is the function to toggle item visibility
     * @return void
     */
    search() {

        // Declare and initialize
        var ctx          = this.context;
        var input        = $(this.input);
        var value        = input.val() || '';
        var form         = input.closest('form');
        var filter       = value.replace(/\W/g, '').toLowerCase();
        var target       = $(form.data(ctx.targetSelector));
        var itemFinder   = form.data(ctx.itemSelector) || '.item';
        var parentFinder = form.data(ctx.parentSelector) || '.item-parent';

        // If there is no target, we can go home
        if (!target || 1 > target.length) return;

        // Run through each item within the target
        target.find(itemFinder).each(function (e) {

            // Show/hide the results
            ctx.toggle(ctx, $(this), filter, itemFinder, parentFinder);

            // Refresh masonry if applicable
            if (form.data('p3-instant-search-masonry'))
                var msnry = new Masonry(form.data(ctx.targetSelector));
        });

    }

    /**
     * Show or hide items based on the existing text filter.
     *
     * @since 1.0.0
     * @method toggleCommunity
     * @param object context is the class context with the functions we need
     * @pararm object ele The current element object
     * @param string filter The current text filter value
     * @param string itemFinder The selector for the group items
     * @param string parentFinder The selector for the item group parent
     * @return void
     */
    toggle(context, ele, filter, itemFinder, parentFinder) {

        // Declare and initialize
        var searching = ele.find('[data-p3-instant-search-text]');

        // If there is no searching element, just use the whole element
        if (!searching.length)
            searching = ele;

        // Process the info we need
        var text     = searching.text().replace(/\W/g, '').toLowerCase();
        var matches  = context.fuzzySearch(text, filter);
        var group    = ele.closest(parentFinder);
        var hasGroup = 0 < group.length;

        // Which is it going to be?
        if (matches) ele.show();
        else ele.hide();

        // If there is no parent group, we are done here
        if (!hasGroup) return;

        // Always show the group
        group.show();

        // Check if any children are visible
        var hasChildren = 0 < group.find(itemFinder + ':visible').length;

        // Hide the parent if there are no visible children
        if (!hasChildren) group.hide();
    }
}

export default InstantSearch;